// extracted by mini-css-extract-plugin
export default {"myleft":"Title_myleft__U5YHa","titleabout":"Title_titleabout__a055Q","titleimage":"Title_titleimage__6n4qD","subheading":"Title_subheading__UwPXt"};